import ColumnWidget from '@components/Widgets/ColumnWidget/ColumnWidget.vue'
import ImageColumn
  from '@components/Widgets/ImageColumnWidget/ImageColumnWidget.vue'
import TwoColumn
  from '@components/Widgets/TwoColumnWidget/TwoColumnWidget.vue'
import FortuneWheel
  from '@components/Widgets/FortuneWheelWidget/FortuneWheelWidget.vue'
import StickyBar
  from '@components/Widgets/StickyBarWidget/StickyBarWidget.vue'
import mapWidgetPosition from '@components/mixins/shared/mapWidgetPosition'
import { mapActions } from 'vuex'
import watermark from '@components/Widgets/_global/Watermark/Watermark.vue'

export default {
  name: 'PreviewModal',
  mixins: [mapWidgetPosition],
  components: {
    watermark,
    'column-widget-component': ColumnWidget,
    'image-column-widget-component': ImageColumn,
    'two-column-widget-component': TwoColumn,
    'fortune-wheel-widget-component': FortuneWheel,
    'sticky-bar-widget-component': StickyBar,
  },
  props: {
    showPreviewModal: {
      type: Boolean,
      required: true,
    },
    targetWidget: {
      type: Object,
      required: true,
    },
    hasWatermark: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isMobile: false,
    }
  },
  computed: {
    widgetComponent() {
      // Guard against null or undefined props
      if (!this.targetWidget || !this.targetWidget.type) return null

      const typeComponentMap = {
        column: 'column-widget-component',
        imageColumn: 'image-column-widget-component',
        twoColumn: 'two-column-widget-component',
        fortuneWheel: 'fortune-wheel-widget-component',
        stickyBar: 'sticky-bar-widget-component',
      }

      return typeComponentMap[this.targetWidget.type] || null
    },
  },
  watch: {
    showPreviewModal: () => {
      this.isMobile = false
      this.setWidgetPosition(this.targetWidget)
    },
  },
  created() {
    this.setTargetStep(this.targetWidget.stepsList[0])
    this.setWidgetPosition(this.targetWidget)
  },
  methods: {
    ...mapActions('campaign/step', ['setTargetStep']),
  },
}
